import React, {  useRef} from "react";
import { 
	RCCButton, 
	RCCTooltip, 
	RCCDropDownItem,
	RCCIcon,
	RCCBadge
} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import PageTitle from "src/components/PageTitle";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import Pagination from "src/components/Pagination";
import { useAuth } from "src/context/Auth/context";
import AppIcons from "src/components/AppIcons";
import SWOTStrategiesModals from "./modals";
import { IRefIStrategyModals } from "./interface";

const Strategies : React.FC = () => { 
	const { translate } = useTranslation();
	const refModals = useRef<IRefIStrategyModals>(null);
	const { superUser,company } = useAuth();
	const hasCredentials = superUser && company.efa002Id === 1 ;

	const paginationRef = useRef<IForwardPagination>(null);

 	const colOptions = (row: any) => (	
		<>
			{hasCredentials &&(
				<OptionsColumn>
					<RCCDropDownItem
						selfEnclose
						onClick={() => { refModals.current?.actionButtonChange(row);  }}
					>
						<RCCIcon name="pencil" 
							style={{ marginRight: "8px" }}
						/>
						{translate("Alterar")}
					</RCCDropDownItem>
					<RCCDropDownItem 
						selfEnclose
						onClick={() => { refModals.current?.actionButtonDelete(row); }}
					>
						<RCCIcon name="trash" 
							style={{ marginRight: "8px" }}
						/>
						{translate("Excluir")}
					</RCCDropDownItem>
				</OptionsColumn>		  
			)}
		</>
	);

	const colSituacao = (row: any) => (
		<>
			{ row.taa015Forca &&
				<RCCBadge color="green"
					styleInline="font-size: 0.83rem;"
				>
					{translate("Força")}
				</RCCBadge>
			}
			{ row.taa015Fraqueza &&
				<RCCBadge color="blue"
					styleInline="font-size: 0.83rem;"
				>
					{translate("Fraqueza")}
				</RCCBadge>
			}
			{ row.taa015Oportunidade &&
				<RCCBadge color="red"
					styleInline="font-size: 0.83rem;"
				>
					{translate("Oportunidade")}
				</RCCBadge>
			}
			{ row.taa015Ameaca &&
				<RCCBadge color="yellow"
					styleInline="font-size: 0.83rem;"
				>
					{translate("Ameaça")}
				</RCCBadge>
			}
		</>
	);

	const translatedRow = (text: string) => (
		<>
			{translate(text)}
		</>
	);

	return (
		<>
			{/* Header -> Results + Buttons */}
			<PageTitle
				title={translate("Estratégias da SWOT")}
				icon={() => <AppIcons name="analysis" />}
			>
				{hasCredentials &&(
					<RCCTooltip
						text={translate("Nova estratégia SWOT")}
						color="purple"
					>
						<RCCButton
							icon={{name: "plus", color: "#FFF", size: 18}}
							color="purple"
							layout="isRounded"
							onClick={() => { refModals.current?.actionButtonAdd(); }}
							size="md"
						/>
					</RCCTooltip>
				)}
			</PageTitle>		

			{/* List */}	
			<Pagination
				ref={paginationRef}
				dataOrRoute="SWOTStrategies/List"
				columns={[
					{
						idColumn: "taa015Titulo",
						nameColumn: translate("Título"),
						xs: 12,
						sm: 3,
						type: "string",
						cellRenderer: (row:any) => translatedRow(row.taa015Titulo)
					},
					{
						idColumn: "taa015Descricao",
						nameColumn: translate("Descrição"),
						xs: 12,
						sm: 4,
						type: "string",
						cellRenderer: (row:any) => translatedRow(row.taa015Descricao)
					},
					{
						idColumn: "taa015Estrategia",
						nameColumn: translate("Estratégia"),
						xs: 12,
						sm: 1,
						type: "string",
						cellRenderer: (row:any) => translatedRow(row.taa015Estrategia)
					},
					{
						idColumn: "taa015Acao",
						nameColumn: translate("Ação"),
						xs: 12,
						sm: 1,
						type: "string",
						cellRenderer: (row:any) => translatedRow(row.taa015Acao)
					},
					{
						idColumn: "bagdes",
						nameColumn: translate("Situação"),
						xs: 12,
						sm: 2,
						cellRenderer: colSituacao,
						disableSort:true
					},
					{
						idColumn: "options",
						nameColumn: " ",
						justify: "right",
						xs: 12,
						sm: 1,
						cellRenderer: colOptions,
						disableSort:true
					}
				]}
			/>
			<SWOTStrategiesModals ref={refModals} paginationRef={paginationRef} />
		</>
	);
};

export default Strategies;
